export * from './baPageTopCustom.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baPageTopCustom/index.ts